"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFRAME_LOADED = exports.READY_EVENT = exports.ANALYTICS_CALLBACK_EVENT = exports.ANALYTICS_EVENT = exports.SOURCE = exports.PRODUCT = void 0;
exports.PRODUCT = 'Flex';
exports.SOURCE = 'flexui';
exports.ANALYTICS_EVENT = 'analytics';
exports.ANALYTICS_CALLBACK_EVENT = 'analytics-callback';
exports.READY_EVENT = 'ready';
exports.IFRAME_LOADED = 'iframe-loaded';
//# sourceMappingURL=constants.js.map